import styled, { css } from 'styled-components';

import { commonAnimation, fadeIn, fadeOut, zoomIn, zoomOut } from './helpers/styleHelpers';

type ModalProps = {
  prefixCls: string;
  padding?: boolean;
};

const Modal = styled.div<ModalProps>(
  ({ prefixCls, padding, theme }) => css`
    .${prefixCls} {
      position: relative;
      width: 500px;
      margin: 10px auto;
      top: 100px;

      &-wrap {
        position: fixed;
        overflow: auto;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        -webkit-overflow-scrolling: touch;
        outline: 0;
      }

      &-mask {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: ${theme.background.mask};
        height: 100%;
        z-index: 1050;
      }

      &-mask-hidden {
        display: none;
      }

      &-content {
        position: relative;
        background-color: ${theme.background.raised};
        border-radius: 6px;
        background-clip: padding-box;
        width: fit-content;
        min-width: 500px;
        box-shadow: ${theme.elevation.level3};
      }

      &-header {
        border-bottom: 1px solid ${theme.border.subtle};
      }

      &-title {
        display: flex;
      }

      &-body {
        padding: ${padding ? '24px' : '24px 0'};
      }

      &-close {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 14px;
        top: 8px;
        width: 28px;
        height: 40px;
        padding: 0;
        border: none;
        border-radius: 2px;
        background: transparent;
        transition: background-color 0.3s;
        cursor: pointer;
      }

      &-close:hover {
        background-color: ${theme.focus.subtle};
      }

      &-footer {
        border-top: 1px solid ${theme.border.subtle};
        padding: 16px 24px;
        text-align: right;
      }

      /* Animations */
      &-zoom-enter,
      &-zoom-appear {
        opacity: 0;
        ${css(commonAnimation)};
        animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
      }

      &-zoom-leave {
        ${css(commonAnimation)};
        animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
      }

      &-zoom-enter.${prefixCls}-zoom-enter-active, &-zoom-appear.${prefixCls}-zoom-appear-active {
        animation-name: ${zoomIn};
        animation-play-state: running;
      }

      &-zoom-leave.${prefixCls}-zoom-leave-active {
        animation-name: ${zoomOut};
        animation-play-state: running;
      }

      &-fade-enter,
      &-fade-appear {
        opacity: 0;
        ${css(commonAnimation)};
        animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
      }

      &-fade-leave {
        ${css(commonAnimation)};
        animation-timing-function: cubic-bezier(0.55, 0, 0.55, 0.2);
      }

      &-fade-enter.${prefixCls}-fade-enter-active, &-fade-appear.${prefixCls}-fade-appear-active {
        animation-name: ${fadeIn};
        animation-play-state: running;
      }

      &-fade-leave.${prefixCls}-fade-leave-active {
        animation-name: ${fadeOut};
        animation-play-state: running;
      }
    }
  `,
);

export { Modal };
